import {FC} from "react";
import {Navigate, Outlet, useRouteLoaderData} from "react-router";

const RedirectIfNotCompany: FC = () => {
  const data = useRouteLoaderData<{
    isComapny: boolean;
    isAdmin: boolean;
    agencyId: number;
  }>("company_root");

  if (!data?.isComapny && !data?.isAdmin) {
    return <Navigate to={`/agency/${data?.agencyId}/dashboard/`} replace />;
  }

  return <Outlet />;
};

export default RedirectIfNotCompany;
